<template>
  <div>
    <div v-if="galleryImgs.length === 0" class="flex justify-center mt-10 mb-8">
      <p> {{ $t('message.customEmails.emptyLibrary') }}</p>
    </div>
    <div v-else class="d-flex mt-6 overflow-y-auto flex-wrap h-64">
      <div v-for="(image, index) in galleryImgs">
        <div class="w-64 h-52 pb-4 pr-6" >
          <button :id="index" @click="selectCompanyImage(image), activePhoto = image" class="pt-1 radius relative" :class="[activePhoto == image ? 'active' : 'non-active']" >
            <div class="flex flex-row justify-center"> 
              <img class="img-size" :src="image" alt="Company image" />
            </div>
            <div v-if="activePhoto == image" class="absolute top-0 right-0 rounded-full bg-white m-2">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" class="w-8 h-8 fill-current" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="#54CAA6" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path>
              </svg>
            </div> 
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'imageLibrary',
    props: {
      galleryImgs: Array,
      selectCompanyImage: Function,
      imageSelected: String
    },
    data() {
      return {
        activePhoto: this.imageSelected
      }
    },
 
  };
</script>

<style scoped>
.active {
  border: 2px solid #54CAA6;
}
.non-active {
  border: 1px solid #CCCCCC;
}
.btn:hover {
  transform: scale(1.1);
}
.radius{
  border-radius: 5px;
}
button {
  width: 190px;
  height: 182px;
}
.p-active {
  background-color: #54CAA6;
  border: 1px solid #54CAA6;
  color: #fff;
}
.img-size{
  max-height: 139px;
  max-width: 186px;
}
</style>
